// extracted by mini-css-extract-plugin
export var hero__content = "hero-module--hero__content--69295";
export var hero__description = "hero-module--hero__description--f8a23";
export var hero__img = "hero-module--hero__img--84567";
export var hero__item = "hero-module--hero__item--88f1e";
export var hero__list = "hero-module--hero__list--a6a03";
export var hero__text = "hero-module--hero__text--b7c35";
export var hero__title = "hero-module--hero__title--f3bff";